<template>
  <v-dialog v-model="visible" max-width="65%">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-help-box</v-icon>
         {{ $t ('Gestionar ticket perdido') }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-stepper v-model="numeroPaso" style="background: #F0F0EE" flat>
          <v-stepper-header>
            <v-stepper-step :complete="numeroPaso > 1" step="1">
              Selección de producto perdido
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="numeroPaso > 2" step="2">
              Datos del nuevo producto
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0">

              <v-card flat tile>
                <v-card-text class="pa-0">
                  <v-data-table
                    v-model="seleccion"
                    :headers="cabeceras"
                    :items="arrayProductos"
                    :loading="cargando"
                    :search="busqueda"
                    :item-class="claseCSSFilaTablaProductos"
                    item-key="clapro"
                    dense
                    single-select
                    @click:row="tablaProductosClickRow"
                    @current-items="tablaProductosCurrentItems"
                    @dblclick:row="tablaProductosDblClickRow"
                  >
                    <template v-slot:top>
                      <v-container style="background: #dcdcd0;" class="px-0">
                        <v-text-field
                          ref="busqueda"
                          style="width: 280px"
                          append-icon="mdi-magnify"
                          v-model="busqueda"
                          label="Buscar producto"
                          class="mx-4"
                          hide-details
                          @keypress.enter="tablaProductosDblClickRow"
                        ></v-text-field>
                      </v-container>
                    </template>

                    <template v-slot:[`item.numpro`]="{ item }">
                      <span class="numero-producto">{{ item.numpro }}</span>
                    </template>
                    <template v-slot:[`item.mat`]="{ item }">
                      <template v-if="item.mat">
                        <span class="matricula">{{ item.mat }}</span>
                      </template>
                    </template>
                    <template v-slot:[`item.estpre`] = "{ item }">
                      {{ $tablasConsulta.registroPorClave ('c_estpre', item.estpre, 'des') }}
                    </template>
                    <template v-slot:[`item.fechorent`] = "{ item }">
                      {{ formatearFechaHora (item.fechorent) }}
                    </template>
                    <template v-slot:[`item.fechorpag`] = "{ item }">
                      {{ formatearFechaHora (item.fechorpag) }}
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" :disabled="seleccion.length==0" @click="botonIrAPaso2">{{ $t ('Siguiente') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

            <v-stepper-content step="2" class="pa-0">

              <v-card flat tile>
                <v-card-text>
                  <v-container fluid>
                    <v-row justify="center">
                      <v-col cols="12" md="8" lg="6">
                        <v-form v-on:submit.prevent v-model="camposValidados" ref="formulario">
                        <v-select
                          ref="grupo_productos"
                          label="Grupo de productos a crear"
                          :items="gruposProductosDisponibles"
                          item-text="des"
                          item-value="cod"
                          prepend-inner-icon="mdi-package-variant"
                          dense
                          v-model="codigoGrupoProductosACrear"
                          :rules="[codigoGrupoProductosACrear != null || 'Requerido']"
                        ></v-select>

                        <v-text-field
                          class="mt-2"
                          v-model="matricula"
                          label="Matrícula"
                          prepend-inner-icon="mdi-car"
                          dense
                          hide-details
                          v-inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }"
                          :disabled="productoPerdidoSeleccionado != null"
                        ></v-text-field>

                        <SelectorFechaHora
                          class="mt-6"
                          titulo-fecha="Fecha"
                          obligatorio
                          titulo-hora="Hora"
                          formato-fecha="cccc, dd/MM/yyyy"
                          formato-hora="HH:mm"
                          literal-null="-"
                          formato-modelo="iso"
                          v-model="fechaHoraUltimoMovimiento"
                          :disabled="productoPerdidoSeleccionado != null"
                        />

                        <v-checkbox
                          class="mt-0"
                          v-model="estanciaPagada"
                          label="Estancia pagada"
                          hide-details
                          :disabled="productoPerdidoSeleccionado != null"
                        ></v-checkbox>

                        <v-text-field
                          class="mt-6"
                          style="margin-right: 50%"
                          v-model="costeProduccion"
                          label="Coste adicional"
                          prepend-inner-icon="mdi-cash-plus"
                          :suffix="$utilI18N.simboloMoneda"
                          dense
                          hide-details
                          v-inputfilter="{ expresionRegular: ['[^0-9.,]', 'g'], longitudMaxima: 6 }"
                        ></v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-btn text color="#90908E" @click="botonIrAPaso1">{{ $t ('Atrás') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" :disabled="!datosNuevoProductoOK" @click="botonIniciarCobro">{{ $t ('Iniciar cobro') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";
import SelectorFechaHora from '@/components/SelectorFechaHora.vue';

export default {
  components: { SelectorFechaHora },
  data () {
    return {
      cabeceras: [
        { text: this.$t ("Núm. producto"), value: "numpro" },
        { text: this.$t ("Grupo productos"), value: "desgrupro" },
        { text: this.$t ("Matrícula"), value: "mat" },
        { text: this.$t ("Estado de presencia"), value: "estpre" },
        { text: this.$t ("Fecha/Hora entrada"), value: "fechorent" },
        { text: this.$t ("Fecha/Hora pago"), value: "fechorpag" },
        { text: this.$t ("Aparato último movimiento"), value: "desapaultmov" },
      ],

      objetoAparato: {},
      sagabroker: null,

      visible: false,
      cargando: false,
      numeroPaso: 1,
      arrayProductos: [],
      gruposProductosDisponibles: [],
      busqueda: '',
      seleccion: [],
      camposValidados: null,

      matricula: '',
      codigoGrupoProductosACrear: null,
      fechaHoraUltimoMovimiento: null,
      estanciaPagada: false,
      costeProduccion: null
    }
  },
  computed: {
    productoPerdidoSeleccionado () {
      if ((this.seleccion.length > 0) && (this.seleccion[0].clapro != null))
        return this.seleccion[0]
      else
        return null;
    },
    datosNuevoProductoOK () {
      return (this.codigoGrupoProductosACrear > 0) && (this.fechaHoraUltimoMovimiento !== null);
    }
  },
  methods: {
    inicializarDatosNuevoProducto() {
      this.matricula = '';
      this.codigoGrupoProductosACrear = null;
      this.fechaHoraUltimoMovimiento = DateTime.now().minus({minutes: 1440-5});
      this.estanciaPagada = false;
      this.costeProduccion = null;
    },
    abrirVentana (objetoAparato, sagabroker) {
      this.objetoAparato = objetoAparato;
      this.sagabroker = sagabroker;

      this.numeroPaso = 1;
      this.arrayProductos = [];
      this.gruposProductosDisponibles = [];
      this.busqueda = '';
      this.seleccion = [];

      this.inicializarDatosNuevoProducto();

      this.visible = true;
      this.cargando = true;

      this.sagabroker.solicitarDatosGestionTicketPerdido (this.objetoAparato.id_ins)
        .then ((mensaje) => {
          this.gruposProductosDisponibles = mensaje.contenido.grupos_productos_disponibles;
          this.arrayProductos = mensaje.contenido.productos;
          this.arrayProductos.unshift ({ clapro: null,
                                         numpro: '(Desconocido)',
                                         desgrupro: '?',
                                         mat: '??????',
                                         estpre: 3,
                                         fechorent: null,
                                         fechorpag: null,
                                         desapaultmov: '?'
                                        });
        })
        .catch(() => {
          alert ('ERROR: Timeout obteniendo datos para la gestión de ticket perdidos');
          this.visible = false;
        })
        .finally(() => {
          this.cargando = false;
        });

      // establecemos el foco en el campo de busqueda
      setTimeout (() => {
        this.$refs['busqueda'].focus();
      }, 250);
    },
    claseCSSFilaTablaProductos (fila) {
      if (fila.clapro == null)
        return "fila-producto-desconocido"
    },
    formatearFechaHora (fechaHoraISO) {
      if (fechaHoraISO != null)
        return DateTime.fromISO (fechaHoraISO).toFormat('dd-MM-yyyy HH:mm');
      else
        return "-";
    },
    tablaProductosClickRow (fila) {
      this.seleccion = [fila];
    },
    tablaProductosCurrentItems (filas) {
      if (filas.length == 1)
        this.seleccion = filas;
      else
        this.seleccion = [];
    },
    tablaProductosDblClickRow () {
      this.botonIrAPaso2();
    },
    botonIrAPaso1 () {
      this.numeroPaso = 1;
    },
    botonIrAPaso2 () {
      if (this.productoPerdidoSeleccionado != null) {
        this.matricula = this.productoPerdidoSeleccionado.mat;
        this.fechaHoraUltimoMovimiento = this.productoPerdidoSeleccionado.fechorpag || this.productoPerdidoSeleccionado.fechorent;
        this.estanciaPagada = (this.productoPerdidoSeleccionado.fechorpag != null);
        this.costeProduccion = null;
      } else
        this.inicializarDatosNuevoProducto();

      if (this.gruposProductosDisponibles.length > 0)
        this.codigoGrupoProductosACrear = this.gruposProductosDisponibles[0].cod;

      if (this.$refs['formulario'])
        this.$refs['formulario'].resetValidation();
      this.numeroPaso = 2;
    },
    botonIniciarCobro () {
      let claveProductoPerdido = null;
      if (this.productoPerdidoSeleccionado != null) {
        claveProductoPerdido = {
          tipo_soporte: parseInt (this.productoPerdidoSeleccionado.clapro.split ('|') [0]),
          identificador_producto: this.productoPerdidoSeleccionado.clapro.split ('|') [1]
        }
      }

      this.sagabroker.ejecutarAccionAparato  (this.objetoAparato.id_ins,
                                              this.$store.operador.correoElectronico,
                                              this.objetoAparato.id_tipapa,
                                              this.objetoAparato.num,
                                              'cobrar_producto_perdido',
                                              {
                                                producto_perdido: claveProductoPerdido,
                                                nuevo_producto: {
                                                  codigo_grupo_productos: this.codigoGrupoProductosACrear,
                                                  matricula: this.matricula,
                                                  ultimo_movimiento: this.fechaHoraUltimoMovimiento,
                                                  estancia_pagada: this.estanciaPagada,
                                                  coste: this.costeProduccion === null ? 0 : parseFloat (this.costeProduccion)
                                                }
                                              }
                                             );
      this.visible = false;
    },
    botonCancelarClick () {
      this.visible = false;
    }
  }
}
</script>

<style>
.fila-producto-desconocido {
  color: #b04040;
  font-weight: bolder !important;
  background-color: thistle;
}
.numero-producto {
  font-family: monospace;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: -0.3px;
}
.matricula {
  font-family: monospace;
  font-weight: 600;
  padding: 1px 4px 1px 4px;
  border: 1px #A0A0A0 solid;
  border-radius: 5px;
  background: #F4F4F4
}
</style>